<main class="pv2-global-additional">
  <header class="pv2-global-additional__header" *ngIf="!loading && group">
    <button type="button" class="pv2-global-additional__back" (click)="goBack()">
      <span class="fa fa-arrow-left"></span>
      <span>Adicionais</span>
    </button>

    <div class="pv2-global-additional__identity">
      <span class="pv2-global-additional__eyebrow">Editor de adicional</span>
      <div class="pv2-global-additional__title-row">
        <h1>{{ group.name }}</h1>
        <span class="pv2-global-additional__requirement" [class.is-optional]="!isRequired">
          {{ isRequired ? 'Obrigatório' : 'Opcional' }}
        </span>
        <span class="pv2-global-additional__usage"
              [class.is-exclusive]="sharedProductNames.length === 1"
              [class.is-shared]="sharedProductNames.length > 1">
          {{ usageLabel }}
        </span>
      </div>
      <p>{{ group.description }} · {{ group.options.length }} {{ group.options.length === 1 ? 'opção' : 'opções' }}</p>
    </div>
  </header>

  <section class="pv2-global-additional__impact" *ngIf="!loading && group && sharedProductNames.length">
    <div>
      <span class="fa" [ngClass]="sharedProductNames.length > 1 ? 'fa-link' : 'fa-lock'"></span>
      <div>
        <strong>{{ sharedProductNames.length > 1 ? 'Alterações compartilhadas' : 'Adicional exclusivo' }}</strong>
        <p>{{ sharedProductNames.length > 1 ? 'Editar este grupo atualiza todos os produtos abaixo.' : 'Este grupo está vinculado somente ao produto abaixo.' }}</p>
      </div>
    </div>
    <div class="pv2-global-additional__product-chips">
      <span *ngFor="let name of sharedProductNames">{{ name }}</span>
    </div>
  </section>

  <section class="pv2-global-additional__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando adicional...</p>
  </section>

  <section class="pv2-global-additional__error" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <h2>Não foi possível abrir o adicional</h2>
    <p>{{ errorMessage }}</p>
    <div>
      <button type="button" (click)="goBack()">Voltar</button>
      <button type="button" class="is-primary" (click)="load()">Tentar novamente</button>
    </div>
  </section>

  <section class="pv2-global-additional__editor" *ngIf="!loading && !errorMessage && editor && group">
    <app-tela-editor-adicional-v2
      [standalone]="true"
      [editor]="editor"
      [empresa]="empresa"
      [podeEditar]="canEditStructure"
      [podeEditarPrecos]="canEditPrices"
      [podeEditarDisponibilidade]="canEditAvailability"
      [podeEditarExibicaoOpcoes]="canEditOptionDisplay"
      [groupId]="group.id"
      [mode]="'edit'"
      [requestedOptionMode]="requestedOptionMode"
      (closeRequested)="goBack()"
      (groupSaved)="onGroupSaved($event)"
      (groupDeleted)="onGroupDeleted()">
    </app-tela-editor-adicional-v2>
  </section>
</main>
